<template>
    <sui-form @submit="onSubmit">
        <GlobalConfig fetchMethod="EXTERNAL_FTP" />
        <FileConfig fetchMethod="EXTERNAL_FTP" />
        <MediaConfig  fetchMethod="EXTERNAL_FTP" />
        <CronConfig />

        <div>
            <h2 is="sui-header">{{ $t('gateway.ftp.title') }}</h2>

            <sui-form-fields :fields="'three'">
                <sui-form-field>
                    <label>URL</label>
                    <div class="ui labeled input">
                        <div class="ui label"><sui-icon name="bullseye violet small icon"></sui-icon></div>
                        <input
                            @focus="onInputFocus"
                            type="text"
                            placeholder="ftp://, sftp://..."
                            v-model="activeGateway.configuration.externalFTPConfiguration.url"
                            required
                        />
                    </div>
                    <MetadataInputList :value="activeGateway.configuration.externalFTPConfiguration.url" property="externalFTPConfiguration.url"/>
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('common.id') }}</label>
                    <div class="ui labeled input">
                        <div class="ui label"><sui-icon name="bullseye violet small icon"></sui-icon></div>
                        <input
                            @focus="onInputFocus"
                            v-model="activeGateway.configuration.externalFTPConfiguration.login"
                            type="text"
                            required
                        />
                    </div>
                    <MetadataInputList :value="activeGateway.configuration.externalFTPConfiguration.login" property="externalFTPConfiguration.login"/>
                </sui-form-field>

                <sui-form-field>
                    <label>{{ $t('common.password') }}</label>
                    <div class="ui labeled input">
                        <div class="ui label"><sui-icon name="bullseye violet small icon"></sui-icon></div>
                        <input
                            @focus="onInputFocus"
                            v-model="activeGateway.configuration.externalFTPConfiguration.secret"
                            type="text"
                            required
                        />
                    </div>
                    <MetadataInputList :value="activeGateway.configuration.externalFTPConfiguration.secret" property="externalFTPConfiguration.secret"/>
                </sui-form-field>
            </sui-form-fields>

            <sui-form-field>
                <sui-checkbox
                    :label="$t('gateway.ftp.doRecursiveFileSearch')"
                    v-model="activeGateway.configuration.externalFTPConfiguration.doRecursiveFileSearch"
                />
            </sui-form-field>
        </div>

        <sui-divider section />
        <sui-button color="violet" fluid>{{ $t('common.save') }}</sui-button>
        
    </sui-form>
</template>

<script>
    import GlobalConfig from '@/components/gateway/fields/GlobalConfig.vue';
    import FileConfig from '@/components/gateway/fields/FileConfig.vue';
    import MediaConfig from '@/components/gateway/fields/MediaConfig.vue';
    import CronConfig from '@/components/gateway/fields/CronConfig.vue';
    import MetadataInputList from '@/components/gateway/MetadataInputList.vue';
    import { mapGetters } from 'vuex';
    import store from '@/store';

    export default {
        name: 'ExternalFTPForm',
        components: {
            GlobalConfig,
            FileConfig,
            MediaConfig,
            CronConfig,
            MetadataInputList,
        },
        methods: {
            onInputFocus(e) {
                this.state.forms.gateway.currentSelectedInput = e.target;
            },
        },
        props: {
            onSubmit: Function,
        },
        computed: {
            state: {
                get() { return store.state; }
            },
            ...mapGetters(['activeGateway']),
        }
    }
</script>